module.exports = __webpack_public_path__ + "media/images/icons/add_new_placeholder-0ca7bc978aa0c7599daf331a8b031fe4.svg";